/***********************/
/* Angular + external */
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";
import { Subscription } from "rxjs";
/***********************/
/* BFX */
// services

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { OECoordinatorService } from "../services/oe-coordinator.service";
import { OEApiService } from "../services/oe-api.service";
// enums
import { OENDisplayState } from "../data/enums/oe-display-state.enum";
import { OENCommand } from "../data/enums/oe-command.enum";
// mappings
// models
import { OEPanelGammaCustomiseModel } from "../data/models/oe-panel-gamma.customise.model";
import { OELoggerService } from "../services/basic/oe-logger.service";
import { TranslateService } from "@ngx-translate/core";
import { OECommandEventModel } from "../data/models/oe-command-event.model";
import { OEPanelGammaLeg } from "../data/models/oe-panel-gamma-leg.model";
import { BfxRequestPriceModel } from "src/app/bfx-interface-controls/models/bfx-interface-controls.models";
import { BigNumber } from "shared/cubiq-model-multi-asset";
import { BfxAmountSpinnerComponent } from "app/bfx-interface-controls/bfx-amount-spinner.component";
import { GammaLegCcyPairTuple } from "../data/models/oe-gamma-leg-pair-tuple.model";
import { NewLegResponse } from "../data/models/oe-panel-gamma-legid-rate.model";
import { runDetached } from "../../../shared/helper-services/run-detached";
import { OEModelLockingService } from "../services/model/oe-model-locking.service";
import { OELockingProfileModel } from "../data/models/oe-locking-profile.model";
import { ICPriceSpinnerComponent } from "../../bfx-element-library/ic-price-spinner.component";
import { ICNInputControlState } from "./controls/models/bfx-interface-controls.enums";

const CUST_BUT_LABEL: string = "oe.entry.gamma.viewer.customise.label";
const RESTORE_BUT_LABEL: string = "oe.entry.gamma.viewer.restore.label";
@Component({
  selector: "bfx-panel-customise",
  templateUrl: "./html/bfx-panel-customise.html",
  standalone: false,
})
export class OECustomisePanelComponent implements OnDestroy, OnInit, AfterViewInit, OnChanges {
  @Input() rootRefId: string;
  @Input() refId: string;
  @ViewChild("customAmount") customAmount: BfxAmountSpinnerComponent;
  @ViewChild("customRate") customRate: ICPriceSpinnerComponent;
  /***************************************/
  /* DATA */

  // Hoist enum for template
  public OENDisplayState = OENDisplayState;
  // Model
  // Display state
  public _displayState: OENDisplayState = OENDisplayState.SHOW_LOADING;

  public buttonLabel: string = "Customise"; //todo ii8n
  public buttonRestoreLabel: string = "Restore"; //todo ii8n
  public activeButtonLabel: string = this.buttonLabel; //todo ii8n
  public gammaTopLeg: OEPanelGammaLeg;
  public requestPriceModel: BfxRequestPriceModel;
  public rate: BigNumber;

  customiseButtonEnabled: boolean;
  ccyPair: any;
  response: NewLegResponse;
  editEnabledByState: boolean;

  public get displayState(): OENDisplayState {
    return this._displayState;
  }

  public set displayState(newDisplayState: OENDisplayState) {}

  private coordinatorSubscription: Subscription;
  private actionPanelSubscription: Subscription;
  private entryPanelSubscription: Subscription;

  public data = new OEPanelGammaCustomiseModel();
  public isEditEnabled: boolean;
  public permissions: boolean;

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    translate: TranslateService,
    protected oeLogger: OELoggerService,
    private coordinator: OECoordinatorService,
    private api: OEApiService,
    public cd: ChangeDetectorRef,
    private locker: OEModelLockingService,
  ) {
    this.oeLogger = oeLogger.for(__dirname);
    this.buttonLabel = translate.instant(CUST_BUT_LABEL);
    this.buttonRestoreLabel = translate.instant(RESTORE_BUT_LABEL);
    this.initializePermissions();
    this.initTopLeg();
    console.log("customise");
  }

  private initTopLeg(): void {
    this.gammaTopLeg = new OEPanelGammaLeg();
    this.gammaTopLeg.amount = new BigNumber(0);
    this.requestPriceModel = new BfxRequestPriceModel();
    this.requestPriceModel.value = new BigNumber(0);
    this.requestPriceModel.textValue = this.requestPriceModel.value.toFixed(6);
    this.gammaTopLeg.rate = new BigNumber(0);
  }

  ngOnInit() {}

  ngOnDestroy() {
    let subscriptions: Subscription[] = [
      this.actionPanelSubscription,
      this.coordinatorSubscription,
      this.entryPanelSubscription,
    ];

    subscriptions
      .filter((s) => s != null)
      .forEach((s) => {
        try {
          s.unsubscribe();
        } catch (e) {
          logger.out.warn(`${this.constructor.name}: Failed to close subscription {${e}}`);
        }
      });
  }

  ngAfterViewInit() {
    this.initialize();
  }

  ngOnChanges(changes: SimpleChanges) {}

  /**********************************************************************/
  /* INITIALIZATION */

  protected initialize(): void {
    this.subscribeToCoordinator();
    this.subscribeToNotificationsCoordinator();
    this.subscribeToEntry();
  }

  public submit(): void {
    if (this.activeButtonLabel == this.buttonLabel) {
      this.isEditEnabled = true && this.editEnabledByState;
      if (this.isEditEnabled) this.activeButtonLabel = this.buttonRestoreLabel;
      this.coordinator.cmdEnableCustomiseGammas(this.rootRefId);
      let gammaLockProfile: OELockingProfileModel = this.locker.createLockForCustomiseGamma(
        this.rootRefId,
      );
      this.coordinator.cmdLoadInterfaceControlLockingProfile(this.rootRefId, gammaLockProfile);
    } else {
      this.activeButtonLabel = this.buttonLabel;
      this.isEditEnabled = false;
      this.coordinator.cmdDisableCustomiseGammas(this.rootRefId);
      this.coordinator.cmdUpdateStrategyLayout(this.rootRefId);

      let gammaUnlockProfile: OELockingProfileModel = this.locker.createUnLockForCustomiseGamma(
        this.rootRefId,
      );
      this.coordinator.cmdLoadInterfaceControlLockingProfile(this.rootRefId, gammaUnlockProfile);
    }
  }

  private initializePermissions(): void {
    // if (this.refId && typeof this.refId === "string" && this.refId.length > 1) {
    //   this.permissions = this.api.getPermissionEnterOrder(this.refId);
    ////  } else {
    //   logger.out.error(
    //      `ERROR: _oePanelActions.initializePermissions(): Unknown refId: '${this.refId}'`,
    //   );
    // }
  }

  private subscribeToEntry(): void {
    this.entryPanelSubscription = this.coordinator.entryPanelCmd$.subscribe(
      ($event: OECommandEventModel) => {
        if ($event.ref === this.rootRefId) {
          this.cd.markForCheck();
          switch ($event.cmd) {
            case OENCommand.LOAD_CONTROLS:
              if (this.api.isGammaCustomizeMode(this.rootRefId)) {
                this.isEditEnabled = true;
                this.activeButtonLabel = this.buttonRestoreLabel;
                this.customiseButtonEnabled = true;
              } else {
                this.isEditEnabled = false;
                this.activeButtonLabel = this.buttonLabel;
                this.customiseButtonEnabled = true;
              }
              break;
          }
        }
      },
    );
  }

  /**********************************************************************/
  /* COORDINATOR HANDLER */
  private subscribeToCoordinator(): void {
    this.coordinatorSubscription = this.coordinator.strategyPanelCmd$
      .pipe(runDetached(this))
      .subscribe(($event: OECommandEventModel) => {
        if ($event.ref === this.refId || $event.ref === this.rootRefId) {
          switch ($event.cmd) {
            case OENCommand.GAMMA_DUPLICATE_LOAD:
              this.isEditEnabled = true;
              this.activeButtonLabel = this.buttonRestoreLabel;
              this.customiseButtonEnabled = true;
              break;
            case OENCommand.GAMMA_TOP_LEG:
              let tuple: GammaLegCcyPairTuple = $event.data;
              this.gammaTopLeg = tuple.leg;
              this.ccyPair = tuple.ccyPair;
              let decs: number = tuple.ccyPair.inverted
                ? tuple.ccyPair.model.spotInvertDecimalsQty
                : tuple.ccyPair.model.limitEntrySpotDecimals;
              this.rate = tuple.leg.rate;
              break;
            case OENCommand.GAMMA_ENABLE_CUST_BUTTON:
              this.customiseButtonEnabled = true;
              break;
            case OENCommand.GAMMA_DISABLE_CUST_BUTTON:
              this.customiseButtonEnabled = false;
              break;
            case OENCommand.GAMMA_NEW_LEG_RESP:
              this.response = $event.data;
              this.customRate.externalState = ICNInputControlState.INVALID as any;
              break;
            case OENCommand.GAMMA_CUSTOM_RATE_CHANGE:
              // WE no longer know that custom rate is invalid so we clear
              this.customRate.externalState = null;
              break;
            case OENCommand.GAMMA_CUST_CCYPAIR_UPDATE:
              this.ccyPair = $event.data;
              break;
            case OENCommand.RESET_ALL:
              this.isEditEnabled = false;
              this.activeButtonLabel = this.buttonLabel;
              this.initTopLeg();
              this.coordinator.cmdDisableCustomiseGammas(this.rootRefId);
              this.coordinator.cmdUpdateStrategyLayout(this.rootRefId);
              let gammaUnlockProfile: OELockingProfileModel =
                this.locker.createUnLockForCustomiseGamma(this.rootRefId);
              this.coordinator.cmdLoadInterfaceControlLockingProfile(
                this.rootRefId,
                gammaUnlockProfile,
              );
              break;
          }
        }
      });
  }

  private subscribeToNotificationsCoordinator(): void {
    this.coordinatorSubscription = this.coordinator.notificationsPanelCmd$.subscribe(
      ($event: OECommandEventModel) => {
        if ($event.ref === this.refId || $event.ref === this.rootRefId) {
          this.cd.markForCheck();

          this.oeLogger.outputDevLogToConsole(
            `DEV: NotificationsPanel -> UPDATE: ${OENCommand[$event.cmd]} | Event: `,
            false,
            $event,
          );

          switch ($event.cmd) {
            case OENCommand.STATE_ORDER_PROCESSING:
              this.editEnabledByState = false;
              this.isEditEnabled = this.editEnabledByState;
              this.activeButtonLabel = this.buttonLabel;
              break;
            case OENCommand.STATE_ORDER_ENTRY:
              this.editEnabledByState = true;
              break;
          }
        }
      },
    );
  }

  public addLeg(data: any): void {
    this.gammaTopLeg.amount = this.customAmount.bigNumberValue;
    this.gammaTopLeg.rate = this.customRate.bigNumberValue;
    this.coordinator.sendCustomLegToViewer(this.rootRefId, this.gammaTopLeg.cloneGammaLeg());
  }
}
